var map = {
	"./ar111.jpg": 7441,
	"./ar1111.jpg": 9010,
	"./ar1112.jpg": 796,
	"./bipin.jpg": 9025,
	"./bulbo.jpg": 2293,
	"./dicro.jpg": 8788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3435;